// Fronted/src/service/cellGroupServices.js
import api from './api';

const cellGroupService = {
  getAllCellGroups: async () => {
    try {
      const response = await api.get('/cell-groups');
      return response.data;
    } catch (error) {
      console.error('Error fetching cellGroups:', error);
      throw error;
    }
  },

  getCellGroupsById: async (id) => {
    try {
      const response = await api.get(`/cell-groups/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching cell group ${id}:`, error);
      throw error;
    }
  },

  getCellGroupByCampus: async (campusId) => {
    try {
      const response = await api.get(`/cell-group/campus/${campusId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching Cell Group by campus ${campusId}:`, error);
      throw error;
    }
  }
};

export default cellGroupService; 